import { Document, Packer, Paragraph, TextRun } from 'docx';
import { saveAs } from 'file-saver';

/**
 * Gera e baixa um .DOCX a partir de texto multilinha (conteúdo editável do contrato).
 */
export async function downloadContratoDocx(texto, filename) {
  const raw = String(texto ?? '').replace(/\r\n/g, '\n');
  const lines = raw.length > 0 ? raw.split('\n') : [' '];
  const doc = new Document({
    sections: [
      {
        properties: {},
        children: lines.map((line) => new Paragraph({ children: [new TextRun({ text: line.length ? line : ' ' })] })),
      },
    ],
  });
  const blob = await Packer.toBlob(doc);
  const safeName = filename && /\.docx$/i.test(filename) ? filename : `${filename || 'contrato'}.docx`;
  saveAs(blob, safeName);
}

export function slugContratoFilename(razaoSocial, empresaId) {
  const base = (razaoSocial || empresaId || 'empresa').toString();
  const slug = base
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80);
  const data = new Date().toISOString().slice(0, 10);
  return `contrato-${slug || 'empresa'}-${data}.docx`;
}
